const iconSize = {
    small: '18',
    medium: '24',
    large: '36',
    'x-large': '48'
}

const itemStyle = {
    display: 'flex',
    alignItems: 'center'
}

const infoStyle = {
    display: 'flex',
    marginLeft: '5px',
    alignItems: 'center'
}

const idStyle = (size) => {
    const fontSize = () => {
        switch (size) {
            case 'small':
                return '0.7rem'
            case 'medium':
                return '0.7rem'
            case 'large':
                return '1rem'
            case 'x-large':
                return '1.3rem'
            default:
                return '0.7rem'
        }
    }

    return {marginLeft: '2px', fontSize: fontSize(size)}
}

const nameStyle = (size) => {
    const fontSize = () => {
        switch (size) {
            case 'small':
                return '0.8rem'
            case 'medium':
                return '1rem'
            case 'large':
                return '1.75rem'
            case 'x-large':
                return '3rem'
            default:
                return '1rem'
        }
    }

    return {fontSize: fontSize(size)}
}

const customIconStyle = (backgroundColor, backgroundImage, size) =>
    console.log(backgroundColor, backgroundImage, size) || {
        backgroundImage,
        backgroundColor,
        backgroundRepeat: 'no-repeat',
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundPosition: 'center',
        display: 'inline-block'
    }

const customIcon = (size, backgroundColor, contentColor) => ({
    container: {
        borderRadius: '50%',
        backgroundColor,
        padding: `${iconSize[size] / 6}px`,
        display: 'flex',
        textAlign: 'center'
    },
    content: {
        color: contentColor || '#fff',
        fontSize: `${iconSize[size]}px`
    }
})

const phoenixIconStyle = {
    borderRadius: '50%',
    padding: '5px',
    margin: '2px'
}

const phoenixInfoStyle = {
    display: 'flex',
    alignItems: 'center'
}

export {
    iconSize,
    itemStyle,
    infoStyle,
    idStyle,
    customIconStyle,
    phoenixIconStyle,
    phoenixInfoStyle,
    customIcon,
    nameStyle
}
